// @flow
import React, { Component } from 'react';
import ProductCardList from 'components/common/ProductCardList/ProductCardList';
import type { State } from 'store';
import { DisplayActions } from 'store/actionCreators';
import type { ProductItem } from 'store/modules/display';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
  supplier: string,
};

type Props = OwnProps & {
  products: ?(ProductItem[]),
  prefetched: ?(ProductItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  selectedCategory: {
    name: string,
    products_count: number,
    parent: any,
  },
  shouldCancel: boolean,
  currentCategory: ?string,
};

class CategoryProductCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const {
      products,
      prefetching,
      loading,
      selectedCategory,
      hasEnded,
      sort,
      supplier,
    } = this.props;
    if (!selectedCategory || !products || products.length === 0 || prefetching || loading) return;
    const lastId = products[products.length - 1].id;
    if (this.props.prefetched) {
      DisplayActions.revealPrefetched('category');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    if (hasEnded) return;
    try {
      await DisplayActions.prefetchCategoryProducts({
        cursor: lastId,
        category: selectedCategory.name,
        sort,
        supplier,
      });
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const {
      selectedCategory,
      shouldCancel,
      currentCategory,
      products,
      sort,
      supplier,
    } = this.props;
    if (
      selectedCategory &&
      currentCategory === selectedCategory.name &&
      products &&
      products.length > 0
    ) {
      return;
    }
    if (!selectedCategory) return;
    try {
      if (!shouldCancel) {
        await DisplayActions.getCategoryProducts({
          category: selectedCategory.name,
          sort,
          supplier,
        });
      }
      await this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { selectedCategory, sort, supplier } = this.props;
    await DisplayActions.getCategoryProducts({
      category: selectedCategory.name,
      sort,
      supplier,
    });
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedCategory !== this.props.selectedCategory) {
      this.initialize();
    }
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
    if (prevProps.supplier !== this.props.supplier) {
      this.listenSort();
    }
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  render() {
    const { selectedCategory } = this.props;
    const placeholderCount = selectedCategory ? selectedCategory.products_count : 6;

    return (
      <ProductCardList
        products={this.props.products}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        placeholderCount={placeholderCount > 12 ? 12 : placeholderCount}
        isTrending={false}
      />
    );
  }
}

const mapStateToProps = ({ display, pender, base, common }: State) => ({
  products: display.category.products,
  prefetched: display.category.prefetched,
  prefetching: pender.pending['display/PREFETCH_CAGEGORY_PRODUCTS'],
  loading: pender.pending['display/GET_CAGEGORY_PRODUCTS'],
  width: base.windowWidth,
  hasEnded: display.category.end,
  selectedCategory: common.categories.selected,
  shouldCancel: common.ssr && !common.router.altered,
  currentCategory: display.category.currentCategory,
});

export default connect(mapStateToProps, () => ({}))(CategoryProductCards);



// WEBPACK FOOTER //
// ./src/containers/list/CategoryProductCards.js